<template>
  <div class="options-container">
    <div class="options">
      <div class="option" v-for="(optionSpec, i) in optionSpecs"
        :key="optionSpec.key || i">
        <div class="option" v-if="optionSpec.type=='section'">
          <div class="section_title">{{ optionSpec.label }}</div>
        </div>
        <div class="option" v-if="optionSpec.type=='choice'">
          <div class="option_title">{{ optionSpec.label }}</div>
          <div class="option_content">
            <select v-model="selectedOptions[optionSpec.key]" :disabled="!optionSpec.enabled">
              <option v-for="opt in optionSpec.values" :value="opt.key" :key="opt.value">{{ opt.label }}</option>
            </select>
          </div>
        </div>
        <div class="option" v-if="optionSpec.type=='integer'" :disabled="!optionSpec.enabled">
          <div class="option_title">{{ optionSpec.label }}</div>
          <div class="option_content">
            <input v-model="selectedOptions[optionSpec.key]" />
          </div>
        </div>
        <div class="option" v-if="optionSpec.type=='checkbox'">
          <el-checkbox v-model="selectedOptions[optionSpec.key]" :label="optionSpec.label" :disabled="!optionSpec.enabled"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ask-parameters',
  props: {
    optionSpecs: {
        type: Array,
        default: ()=>([])
      },
    selectedOptions: {
        type: Object,
        default: ()=>({})
      },
  },
};
</script>

<style scoped lang="scss">
.options-container {
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .options {
    display: flex;
    flex-direction: column;
    padding: 10px;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .option {
      display: flex;
      flex-direction: column;
      margin-bottom: 5px;
      .section_title {
        font-size: 18px;
        font-weight: 700;
        color: $grey-8-mayday;
        border-top: 1px solid lightgray;
      }
      .option_title {
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 5px;
      }
      .option_content {
        display: flex;
        flex-direction: column;
        select {
          padding: 5px;
          border: 1px solid $grey-2-mayday;
          border-radius: 5px;
          font-size: 14px;
          font-weight: 400;
          background-color: white;
        }
      }
    }
  }
}

</style>
